import React from 'react';

export interface ZapisDoplnenehoStanoviskaFormDataContextContent {
  generatedFile?: File;
  setGeneratedFile?: (file: File) => void,
}

export default React.createContext<ZapisDoplnenehoStanoviskaFormDataContextContent>({
  generatedFile: undefined,
  setGeneratedFile: undefined,
});
